(function($) {

    $(document).ready(function() {
        $.each($('.owl-slider'), function() {
          	var autoplay = $(this).attr("data-autoplay");
          	autoplay = autoplay && autoplay != "false" ? autoplay : false;
          	var items = parseInt($(this).attr("data-items"));
          	var items600 = items <= 3 ? items : 3;

            $(this).owlCarousel({
                loop: true,
                margin: 10,
              	nav: false,
              	autoplay: autoplay,
  		    	autoplayTimeout:1000,
    			autoplayHoverPause:true,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1
                    },
                    600: {
                        items: items600
                    },
                    1000: {
                        items: items
                    }
                }
            });
        }); 
    });

})(jQuery)